import { memo } from 'react';
import { useNavigate } from 'react-router-dom';

import { useDeckEditor } from 'com/DeckEditor';
import { apiDeleteDeck, apiGetBackup, getBackupFileName } from 'core/api';
import { saveAsFile } from 'core/helpers/browser';
import { getDeckGraphUrl } from 'core/paths';
import { MenuItem } from 'core/ui/Menu';
import { useMessageModal } from 'core/ui/MessageModal';
import ICONS from 'core/ui/icons';

export default memo(function MenuBody({
  deck,
  reload,
}: {
  deck: TDeckRich;
  reload: () => Promise<void>;
}) {
  const { editDeck } = useDeckEditor();
  const { showError } = useMessageModal();
  const navigate = useNavigate();

  return (
    <>
      <MenuItem
        label="Edit"
        icon={ICONS.Edit}
        onClick={() => editDeck(deck.uid).then(reload)}
      />
      <MenuItem
        label="Show stats"
        icon={ICONS.Graph}
        onClick={() => navigate(getDeckGraphUrl(deck.uid))}
      />
      <MenuItem
        label="Remove"
        icon={ICONS.Trash}
        onClick={() => {
          if (
            confirm(
              `Are you sure? It's irreversible! The deck will be deleted with all its cards!`
            ) &&
            confirm('Once again')
          ) {
            apiDeleteDeck(deck.uid).then(reload).catch(showError);
          }
        }}
      />
      <MenuItem
        label="Export"
        icon={ICONS.Export}
        onClick={() =>
          apiGetBackup(deck.uid)
            .then(data => saveAsFile(data, getBackupFileName(deck.uid)))
            .catch(showError)
        }
      />
    </>
  );
});
